import { render, staticRenderFns } from "./ColumnSetting.vue?vue&type=template&id=1ef0f593&"
import script from "./ColumnSetting.vue?vue&type=script&lang=js&"
export * from "./ColumnSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports